module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-uploader"
  }, [_c('input', {
    ref: "imageUploader",
    staticClass: "image-uploader__input-hidden",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "hidden": ""
    },
    on: {
      "change": _vm.changeFile
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-uploader__box",
    on: {
      "click": _vm.chooseFileTrigger
    }
  }, [_c('img', {
    ref: "imageBoxImg",
    attrs: {
      "src": "",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-uploader__new"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.chooseFileTrigger
    }
  }, [_vm._v("\n      Choose new\n      "), (_vm.imageIsLoading) ? _c('span', {
    staticClass: "btn-loader"
  }) : _vm._e()])]), _vm._v(" "), (_vm.imageChanged && _vm.uploadedImgUrl) ? _c('div', {
    staticClass: "image-uploader__old"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.returnOldImage
    }
  }, [_vm._v("Return old")])]) : _vm._e(), _vm._v(" "), (_vm.imageExist && _vm.removable) ? _c('div', {
    staticClass: "image-uploader__remove"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.removeImage
    }
  }, [_vm._v("Remove image")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e7f7676","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/global/components/ImageUploader.vue
// module id = 960
// module chunks = 0